import React from 'react'
import './ToolTipBox.scss'
import arrow from '@assets/images/tooltip/tooltip-arrow.png'

interface ToolTipBoxProps {
  numberOfColumns: number
  children: React.ReactNode
}

export function ToolTipBox({ numberOfColumns, children, ...rest }: ToolTipBoxProps) {
  return (
    <div className="tooltip-box" style={{ width: `${numberOfColumns * 6}rem` }} {...rest}>
      {children}
      <img id="arrow" data-popper-arrow src={arrow} alt="tooltip-arrow" />
    </div>
  )
}
